export const optionsTree = (items, subKey, itemRender, exclude?, level = 0) => {
  return items.reduce((prev, item) => {
    if (exclude && exclude(item, level)) return prev
    prev.push(itemRender(item, '-'.repeat(level * 2)))
    const subTree = item[subKey] || []
    if (subTree.length > 0)
      return prev.concat(
        optionsTree(subTree, subKey, itemRender, exclude, level + 1)
      )
    return prev
  }, [])
}

export const countSubTrees = (parent, subKey) =>
  (parent[subKey] || []).reduce((prev, item) => {
    if (item[subKey]) return prev + countSubTrees(item, subKey)
    return prev
  }, 1)

export const timeQuery = (url: string | undefined, date: Date) =>
  url && `${url as string}?t=${date.getTime()}`

import natsort from 'natsort'

export const narutalSort = (
  array: any[], // tslint:disable-line:no-any
  key?: string,
  desc: boolean = false
) => array.sort((a, b) => natsort({desc})(key && a[key], key && b[key]))

export const objectValues = (object: object) => {
  const keys = Object.keys(object)
  let values: any[] = [] // tslint:disable-line:no-any
  for (let i = 0, length = keys.length; i < length; i++) {
    values.push(object[keys[i]])
  }
  return values
}

export const mapValues = (object: object, iteratee: Function) => {
  const keys = Object.keys(object)
  for (let i = 0, length = keys.length; i < length; i++) {
    object[keys[i]] = iteratee(object[keys[i]])
  }
  return object
}

const isObject = item =>
  item && typeof item === 'object' && !Array.isArray(item)

export const mergeDeep = (target, ...sources) => {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, {[key]: {}})
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, {[key]: source[key]})
      }
    }
  }

  return mergeDeep(target, ...sources)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Utils.ts